import { motion } from "framer-motion";
import createStars from "../utils/createStars";
import { iconItem } from "../styles/variants";

export default function SkillIcon({data}) {
    const { icon, alt, name, stars } = data;
    return (
        <motion.div
            className='flex flex-col items-center justify-between w-24 lg:h-32' 
            variants={iconItem}
        >
            <div className='flex lg:w-11 lg:h-11 items-center'>
                <img 
                    src={icon}  
                    alt={alt} 
                    className="w-11 max-h-11 hidden lg:flex lg:max-w-[482px] mx-auto" 
                />
            </div>
            <h3 className='break-words text-center leading-none'>{name}</h3>
            <div className='flex'>
            {createStars(stars)}
            </div>
        </motion.div>
    )
}
